import { assetUrl } from '../api/assets';

export const HABITAT_DOCK_ICONS = {
  feed: 'ui_icon_habitat_feed',
  play: 'ui_icon_habitat_play',
  dress: 'ui_icon_habitat_dress',
  equip: 'ui_icon_habitat_equip',
  looks: 'ui_icon_habitat_looks',
  abilities: 'ui_icon_habitat_abilities',
} as const;

export type HabitatDockIconId = keyof typeof HABITAT_DOCK_ICONS;

export function HabitatDockIcon({ id }: { id: HabitatDockIconId }) {
  return (
    <img
      className="habitat-dock-cel"
      src={assetUrl(HABITAT_DOCK_ICONS[id])}
      alt=""
      draggable={false}
    />
  );
}
